export default "__VITE_ASSET__COG8O9WI__"